import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as PointQL from "queries/point";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { Mutation, Button } from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params,
    params: { pointId },
  },
}) => {
  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the point <b>{pointId}</b>? This action will be permanent and
            can't be undone
          </Col>
        </Row>
        <Mutation
          mutation={PointQL.remove}
          update={PointQL.update(params)}
          onMutate={({ handler }) => {
            handler({
              variables: {
                pointId
              },
            });
          }}
          onCompleted={() => {
            history.replace(`/point`);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
